import { call, put, select, takeEvery } from 'typed-redux-saga'
import { errorHandler, notifyMessageCreator } from 'Modules'
import { Deserialize } from 'cerialize'
import { RequestParams, ResponseCatalog } from 'Models'
import {
	SmsLimitModel,
	SmsStatsModel,
	smsSettingsSelector,
	SmsRuleModel,
	smsSettingsApi,
	SmsSettingsNS,
	smsSettingsSlice,
} from 'Pages/som'

function* getAll(action: SmsSettingsNS.GetAll) {
	try {
		let currentParams: RequestParams
		const {
			payload: { params, searchMissing },
		} = action

		const catalogSmsRules = yield* select(smsSettingsSelector.getAll)
		if (params) {
			currentParams = params
		} else {
			currentParams = yield* select(smsSettingsSelector.getParams)
		}

		const res = yield* call(smsSettingsApi.getAll, currentParams)
		let smsRules = new ResponseCatalog<SmsRuleModel>(res)
		if (searchMissing) {
			catalogSmsRules.entries = [...catalogSmsRules.entries, ...res.entries]
			smsRules = new ResponseCatalog<SmsRuleModel>(catalogSmsRules)
		}
		yield* put(smsSettingsSlice.actions.setAll(smsRules))
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

function* createOne(action: SmsSettingsNS.CreateOne) {
	try {
		yield* call(smsSettingsApi.createOne, action.payload)
		const requestParams = yield* select(smsSettingsSelector.getParams)
		yield* put(smsSettingsSlice.actions.getAll(requestParams))
		yield* call(notifyMessageCreator, 'common.rule_create.success')
	} catch (error) {
		yield* call(errorHandler, error)
	}
}
function* updateOne(action: SmsSettingsNS.UpdateOne) {
	try {
		const { id, data } = action.payload
		yield* call(smsSettingsApi.updateOne, id, data)
		const requestParams = yield* select(smsSettingsSelector.getParams)
		yield* put(smsSettingsSlice.actions.getAll(requestParams))
		yield* call(notifyMessageCreator, 'common.rule_update.success')
	} catch (error) {
		yield* call(errorHandler, error)
	}
}
function* deleteOne(action: SmsSettingsNS.DeleteOne) {
	try {
		yield* call(smsSettingsApi.deleteOne, action.payload)
		const requestParams = yield* select(smsSettingsSelector.getParams)
		yield* put(smsSettingsSlice.actions.getAll(requestParams))
		yield* call(notifyMessageCreator, 'common.rule_delete.success')
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

function* getSmsStats() {
	try {
		const res = yield* call(smsSettingsApi.getSmsStats)
		yield* put(smsSettingsSlice.actions.setSmsStats(Deserialize(res?.parts, SmsStatsModel)))
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

function* getSmsLimit() {
	try {
		const res = yield* call(smsSettingsApi.getSmsLimit)
		yield* put(smsSettingsSlice.actions.setSmsLimit(Deserialize(res, SmsLimitModel)))
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

function* updateSmsLimit(action: SmsSettingsNS.UpdateSmsLimit) {
	try {
		const { data } = action.payload
		yield* call(smsSettingsApi.updateSmsLimit, data)
		yield* put(smsSettingsSlice.actions.getSmsLimit())
		yield* call(notifyMessageCreator, 'common.limits_update.success')
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

export const smsSettingsSaga = function* saga() {
	yield* takeEvery(smsSettingsSlice.actions.getAll.type, getAll)
	yield* takeEvery(smsSettingsSlice.actions.createOne.type, createOne)
	yield* takeEvery(smsSettingsSlice.actions.updateOne.type, updateOne)
	yield* takeEvery(smsSettingsSlice.actions.deleteOne.type, deleteOne)
	yield* takeEvery(smsSettingsSlice.actions.getSmsStats.type, getSmsStats)
	yield* takeEvery(smsSettingsSlice.actions.getSmsLimit.type, getSmsLimit)
	yield* takeEvery(smsSettingsSlice.actions.updateSmsLimit.type, updateSmsLimit)
}
